// src/sim/ai/coordination/constants.ts — P4 coordination tunables (D-14, D-15, D-16).
// Tick-based at 30 Hz. TODO(P7 POL-06): retune from playtest.
//
// Source: .planning/phases/04-ai/04-CONTEXT.md D-14..D-16; 04-RESEARCH.md Pattern 7, 8, 9.

/** D-14: initial Gaussian spread for sighting entries at various confidence levels (in pixels). */
export const P4_BLACKBOARD_LOW_INITIAL_SIGMA_PX = 64;
export const P4_BLACKBOARD_ALERTED_INITIAL_SIGMA_PX = 64; // D-12 Alerted write
export const P4_BLACKBOARD_MEDIUM_INITIAL_SIGMA_PX = 32;
export const P4_BLACKBOARD_SPOTTED_INITIAL_SIGMA_PX = 16; // D-12 Spotted write
export const P4_BLACKBOARD_HIGH_INITIAL_SIGMA_PX = 16;

/** D-14: sigma grows at this rate per tick (~15 px/s at 30 Hz). */
export const P4_BLACKBOARD_SIGMA_GROWTH_PER_TICK = 0.5; // px/tick

/** D-14: entries older than this are pruned. 12 s * 30 Hz = 360 ticks. */
export const P4_BLACKBOARD_MAX_AGE_TICKS = 360;

/** D-15: each wall tile crossed along the shout straight-line adds this to effective distance. */
export const P4_SHOUT_WALL_PENALTY_TILES = 2;

/** D-16: investigate-division utility scorer weights. */
export const P4_INVESTIGATE_BASE = 0.4;
export const P4_INVESTIGATE_DISTANCE_WEIGHT = 0.5;
export const P4_INVESTIGATE_DUPLICATE_WEIGHT = 0.3;
export const P4_INVESTIGATE_CONFIDENCE_WEIGHT = 0.3;
